import { createUseStyles } from 'react-jss';

import { FontWeight, mediaQuery } from '../../../styles';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles<string, { imgMaxHeight: number | null }>(
  ({ breakpoints }: ITheme) => ({
    root: {
      maxWidth: '664px',
      marginBottom: 80,

      [mediaQuery(breakpoints.tablet)]: {
        marginBottom: 60,
      },
    },

    question: {
      fontSize: '36px',
      lineHeight: '48px',
      color: 'var(--x-accent-2-1)',
      fontWeight: FontWeight.Medium,
      marginBottom: 48,

      [mediaQuery(breakpoints.tablet)]: {
        marginBottom: 32,
        fontSize: '30px',
        lineHeight: '36px',
      },
    },

    imgContainer: {
      backgroundImage: `linear-gradient(to bottom, #7B49BA -100% ,rgba(255, 255, 255, 0) 60%),url('https://cdn140.picsart.com/30197624169104334071.webp')`,
      backdropFilter: 'blur(84px)',
      borderRadius: 16,
      marginBottom: 48,
      display: 'flex',
      justifyContent: 'center',
      height: 230,

      '& img': {
        margin: 'auto',
        maxWidth: '100%',
        maxHeight: ({ imgMaxHeight }) => imgMaxHeight ?? '100%',
        verticalAlign: 'top',
      },

      [mediaQuery(breakpoints.tablet)]: {
        marginBottom: 32,
      },
    },
    answer: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: FontWeight.Medium,
      margin: 'auto',
      color: 'var(--x-text-color-2)',
    },
  }),
  {
    name: 'table-content',
  },
);

export default useStyles;
